import { Skeleton } from "@/app/admin/_common/ui/skeleton";

export default function RequestListSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
      <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3 w-14" />
        <Skeleton className="ml-auto h-3 w-16" />
        <Skeleton className="size-4 flex-none rounded" />
      </div>
      {Array.from({ length: 10 }).map((_, i) => (
        <div
          key={i}
          className="flex h-[38px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
        >
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-3 w-32" />
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-5 w-14 rounded-full" />
          <Skeleton className="ml-auto h-3 w-16" />
          <Skeleton className="size-4 flex-none rounded" />
        </div>
      ))}
    </div>
  );
}
